export const TOAST_TYPES = {
  'INFO': 'info',
  'SUCCESS': 'success',
  // Действие не разрешено правилами («нельзя», «не хватает», «уже»): игрок ничего не
  // сломал и просто пробует другое. Ошибка — когда что-то действительно не удалось или
  // игрок понес потерю
  'WARNING': 'warning',
  'ERROR': 'error',
}

/** Своя иконка на язычке тоста вместо значка типа (см. withToastIcon) */
export const TOAST_ICONS = {
  'INITIATIVE': 'initiative',
  'STEAL': 'steal',
  'TRAP': 'trap',
  'COINS': 'coins',
}
